import type { JobListing } from "#/types/types";

export default function LocumJobs({ postings }: { postings: JobListing[] }) {
  const job = postings[postings.length - 1];
  return (
    <article className="rounded-lg border border-stone-400 bg-white p-5">
      <h3 className="mb-3 border-b border-stone-200 pb-2 text-xl font-bold">
        Short-term locum Anesthesiologist needed in {job?.city}
      </h3>
      <div className="space-y-1">
        <h4 className="mt-1 font-bold">Job Responsibilites</h4>
        <ul className="list-inside list-disc ">
          {job?.responsibilities.map((detail: string) => {
            return <li className="m-0">{detail}</li>;
          })}
        </ul>
      </div>

      <div className="mt-3">
        <button
          type="button"
          className="rounded-lg bg-sky-500 px-4 py-2 text-center text-sm font-medium text-white hover:bg-sky-800 focus:outline-none focus:ring-4 focus:ring-blue-300"
        >
          Apply for Locum Anesthesiologist
        </button>
      </div>
    </article>
  );
}
